<template>
    <div class="flex-column mb-0 jc-center hp-10">
        <div class="acenter mb-6">
            <img
                src="/ressources/public/img/onboarding/Sellsy_produit_onboarding3.png"
                class="w-5 mb-8"
            />
            <slot>
                <h1 class="mb-2">
                    {{ $l10n.__('Merci de votre confiance et bonne journée sur Sellsy !') }}
                </h1>

                <CompassButton
                    :label="$t.__('common.actions.go_sellsy')"
                    class="mt-4"
                    @click="homeUrl"
                />
            </slot>
        </div>
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
export default {
    methods: {
        homeUrl() {
            return goToUrl('/home');
        },
    },
};
</script>
